<template>
	<layout>
		<pagetitle>{{ branch.title }}</pagetitle>

		<div class="row mb-5">
			<div class="col-12 col-md-4">
				<img :src="branch.image" width="100%">
			</div>
			<div class="col-12 col-md-8 t-white">
				<div v-html="branch.content" class="pt-3"></div>
				<a :href="'/users/branch/'+branch.id" class="btn btn-theme mt-3 mb-3">Medewerkers</a>
			</div>
		</div>
		
		<pagetitle><span v-if="messagetype"><i :class="message.type.icon + ' bigIcon'"></i> {{ message.type.title }}</span><span v-else>Bericht maken</span></pagetitle>
		<div class="row mb-5" v-if="!messagetype">

			<div class="col-4 col-md-3" v-for="(messagetype, index) in messagetypes" :key="index" @click="createMessage(messagetype.id)">
				<div v-if="messagetype.id == 5">
					<div class="card mb-2" v-if="user.CanCreateWhitelist">
						<div class="card-block text-center p-5 bg-color">
							<i :class="messagetype.icon+ ' bigIcon'"></i>
						</div>
						<div class="card-footer text-muted text-center" v-html="messagetype.title">
						</div>

					</div>
				</div>

				<div v-else-if="messagetype.id == 6">
					<div class="card mb-2" v-if="user.CanCreateBlacklist">
						<div class="card-block text-center p-5 bg-color">
							<i :class="messagetype.icon+ ' bigIcon'"></i>
						</div>
						<div class="card-footer text-muted text-center" v-html="messagetype.title">
						</div>

					</div>
				</div>

				<div class="card mb-2" v-else>
					<div class="card-block text-center p-5 bg-color">
						<i :class="messagetype.icon+ ' bigIcon'"></i>
					</div>
					<div class="card-footer text-muted text-center" v-html="messagetype.title">
					</div>

				</div>
			</div>
		</div>
		<div class="row mb-5 pt-3 bg-white" v-else>
			<div class="col-12">
				<a href="#" @click="cancelMessage()" class="btn btn-theme">Annuleer</a>
			</div>
			<div class="col-12 mt-4">
                <form action="" @submit.prevent="submitMessage()">
                    <div class="form-row">
                        <div class="form-group col-12">
                            <label>Titel<span>*</span></label>                            
                            <input class="form-control" v-model="message.data.title" type="text" @change="editing()">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12">
                            <label>Bericht<span>*</span></label>                            
                            <tinymce-editor v-model="message.data.content" class="form-control" @change="editing()" :init="{height: 400, force_br_newlines:true}" plugins="lists" toolbar="undo redo | styleselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist"></tinymce-editor>
                        </div>
                    </div>

                    <!-- TODO Aladesiun -->
                    <!-- The upload object is message.data -->
                    <div class="form-row">
                        <div class="form-group col-12">
							<table class="table">
								<thead>
									<tr>
										<td>Foto's:</td>
										<!-- If pressed add another file upload possibility  -->
										<!-- File can be a PDF or image -->
										<input type="file" class="d-none" @change="readSelectedFile()" id="addfile"/>
										<td><button @click="triggerAddFile()" class="btn btn-theme mt-2 mb-2">Bestand toevoegen</button></td>
									</tr>
								</thead>
								<tbody>
									<!-- foreach file: -->
									 <tr :key="'d'+index" v-for="(file,index) in edittingfiles">
										<td v-if="message.data.id">
											<div class="col-12 mt-0 filesholder"> 
												<span>
													<a href="#" v-if="checkImageFile(file.filetype)" class="file" target="_blank">
														<img style="width:100%;height:100%" :src="endpoint+'view-file/'+user.id+'/'+message.data.id+'/'+file.id+'/'+file.name" />
													</a>
													<a href="#" v-else class="file" :style="'background:url(https://banner2.kisspng.com/20180422/zww/kisspng-pdf-computer-icons-document-file-format-pdf-5add323811da83.1161637015244457520731.jpg)'"></a>
												</span>
											</div>
										</td>
										<td>{{file.name}}</td>
										<td><button @click="removeedittingfile(index)" class="btn btn-danger btn-sm"><i class="fas fa-times"></i></button></td>
										<!-- <td><input type="file" class="form-control"></td>
										<td><a href="#" class="btn btn-danger">remove file</a></td> -->
									</tr>

									<tr :key="index" v-for="(file,index) in selectedfiles"> 
										<td>{{file.name}}</td>
										<td><button @click="removefile(index)" class="btn btn-danger btn-sm"><i class="fas fa-times"></i></button></td>
									</tr>
								</tbody>
							</table>
							
                        </div>
                    </div>

					<div class="form-row" v-if="allow_sent">
                    	<div class="form-group col-6" v-if="removeBtn">
                			<a ref="#" class="btn btn-party btn-block btn-danger p-2" @click="deleteMessage()">
                            	Verwijder Bericht
                        	</a>
	                    </div>
                    	<div class="form-group col-6" v-if="removeBtn">
                        	<a ref="#" class="btn btn-party btn-block btn-theme p-2" @click="updateMessage()">
                            	Bewerken
                        	</a>
                        </div>

					</div>
                    
                    <div class="alert alert-danger" role="alert" v-if="!allow_sent">
                    	Voer een bericht en titel in om een bericht te plaatsen...
                    </div>
					<div class="form-group" v-if="!removeBtn">
                        <a ref="#" class="btn btn-party btn-block btn-theme btn-block p-2" @click="storeMessage()">
                            Aanmaken
                        </a>
                    </div>
                </form>
			</div>
		</div>

		<div id="berichten"></div>
		<pagetitle>Berichten</pagetitle>
		<div class="row mb-2 bg-white">
			<div class="col-12 pt-2 pb-2">
				<div class="form-row">
					<div class="form-group col-3">
						<select class="form-control" v-model="search.messagetype_id" @change="searchMessages()">
							<option value="false">-- Alle berichttypen --</option>
							<option v-for="(messagetype, index) in messagetypes" :key="index" :value="messagetype.id">{{ messagetype.title }}</option>
						</select>
					</div>

					<div class="form-group col-3">
						<select class="form-control" v-model="search.user_id" @change="searchMessages()">
							<option value="false">-- Alle Medewerkers --</option>
							<option v-for="(user, index) in allUsers" :key="index" :value="user.id">{{ user.firstname }} {{ user.lastname }}</option>
						</select>
					</div>
					<div class="form-group col-4" @keyup.enter="searchMessages()">
						<input type="text" class="form-control" placeholder="Zoekwoorden..." v-model="search.keywords">
					</div>
					<div class="form-group col-2">
						<a href="#berichten" class="btn btn-theme" @click="searchMessages()"><i class="fas fa-search"></i></a>
					</div>
				</div>
			</div>
		</div>
		
		<div class="row mb-2 bg-white" v-for="(message, index) in messages" :key="index" :class="{'mt-2': index==0}">
			<div class="hidden-sm-down col-md-3 pl-0 pr-0 br-1">
				<div class="card mb-2">
					<div class="card-block text-center p-5 bg-color">
						<i :class="message.messagetype.icon + ' bigIcon'"></i>
					</div>
					<div class="card-footer bg-white text-center" v-html="message.messagetype.title">
					</div>
				</div>
			</div>
			<div class="col-md-9 pt-3 pb-3 message">
				<div class="row">
					<div class="col-12 mb-3">
						<div class="messageHead">
							<h2><span v-if="(message.user_id == user.id && timeCheck(message)) || checkUserHasPermission('edit message')"><a href="#" @click="editMessage(message.id)"><i class="fas fa-pen-square"></i></a>&nbsp;</span>{{ message.title }}</h2>
							<span>
								<a :href="'/profile/'+message.user.id" v-if="message.hasOwnProperty('user')">{{ message.user.firstname }} {{ message.user.lastname }}</a>
								op {{ message.datum }}
							</span>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-10" v-html="message.content">
					</div>
				</div>
				<div class="row">
					<div class="col-12 filesholder"> 
						<span v-for="(file,index) in message.files" :key="index">
							<a :href="endpoint+'view-file/'+user.id+'/'+message.id+'/'+file.id+'/'+file.name" v-if="checkImageFile(file.filetype)" class="file" target="_blank">
								<img style="width:100%;height:100%" :src="endpoint+'view-file/'+user.id+'/'+message.id+'/'+file.id+'/'+file.name" />
							</a>
							<a :href="endpoint+'view-file/'+user.id+'/'+message.id+'/'+file.id+'/'+file.name" v-else class="file" target="_blank">
								<img style="width:100%;height:100%" src="https://banner2.kisspng.com/20180422/zww/kisspng-pdf-computer-icons-document-file-format-pdf-5add323811da83.1161637015244457520731.jpg" />
							</a>
						</span>
					</div>
				</div>
			</div>
		</div>

		<div class="row mb-5">
			<div class="col-12 text-center p-3 mt-3 mb-5">
				<nav aria-label="pagination" v-if="pagination">
					<ul class="pagination justify-content-center mt-3">
						<li class="page-item" :class="{'disabled': page.first == page.current}">
							<a class="page-link" href="#berichten" @click="goToPage(page.first)">Eerste</a>
						</li>
						<li class="page-item" :class="{'disabled': page.current -1 <= 0}">
							<a class="page-link" href="#berichten" @click="goToPage(page.current-1)">Vorige</a>
						</li>
						<li class="page-item" id="pageNumberPageItem">
							<select class="form-control page-link" @change="goToPage('pageNumber')" id="pageNumber" v-model="pagination.current">
								<option v-for="n in page.num" :key="n" :class="{'active':n==page.current}">
									{{ n }}
								</option>
							</select>
						</li>
						
						<li class="page-item" :class="{'disabled': page.current >= page.last}">
							<a class="page-link" href="#berichten" @click="goToPage(page.current+1)">Volgende</a>
						</li>
						
						<li class="page-item" :class="{'disabled': page.last == page.current}">
							<a class="page-link" href="#berichten" @click="goToPage(page.last)" >Laatste</a>
						</li>
					</ul>
				</nav>
			</div>
		</div> 
		<div class="modal fade" id="confirmModal" tabindex="-1" role="dialog" aria-labelledby="confirmModal" aria-hidden="true">
		  <div class="modal-dialog" role="document">
		    <div class="modal-content">
		      <div class="modal-body alert-danger text-center">
		      	
					Weet je zeker dat je het bericht niet wilt opslaan?
				
		      </div>
		      <div class="modal-footer text-center">
		        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="confirmCancel()">Bewerkingen Verwijderen</button>
		        <button type="button" class="btn btn-theme" data-dismiss="modal">Doorgaan met bewerken</button>
		      </div>
		    </div>
		  </div>
		</div>
		

		<div :style="($store.state.alertMessage.msg != '')? 'display:block':'display:none'" class="modal fade show" id="AlertModal" tabindex="-1" role="dialog" aria-labelledby="AlertModal" aria-hidden="true">
		  <div class="modal-dialog" role="document">
		    <div class="modal-content">
		      <div class="modal-body text-center">
				  <!-- <div><i class="fas fa-bell"></i></div> -->
					{{$store.state.alertMessage.msg}}

		      </div>
		      <div class="modal-footer text-center"> 
		        <button @click="$store.commit('setNotification','')" type="button" class="btn btn-theme btn-sm m-auto" data-dismiss="modal">Close</button>
		      </div>
		    </div>
		  </div>
		</div>


		<div :style="($store.state.requestStatus.show )? 'display:block':'display:none'" class="modal fade show" id="AlertModal" tabindex="-1" role="dialog" aria-labelledby="AlertModal" aria-hidden="true">
		  <div class="modal-dialog" role="document">
		    <div class="modal-content">
		      <div class="modal-body text-center">
				  <!-- <div><i class="fas fa-bell"></i></div> -->
					{{$store.state.requestStatus.perc + '%'}}

		      </div> 
		    </div>
		  </div>
		</div>

		<!-- <button data-toggle="modal" data-target="#AlertModal" class="btn">toggle</button> -->

	</layout>
</template>

<script>
	import layout from '../layout/layout.vue'

	// es modules
	import Editor from '@tinymce/tinymce-vue'
	// commonjs require
	// NOTE: default needed after require
	// Editor = require('@tinymce/tinymce-vue').default;

	export default {

		name: 'branch',

		components:{
			layout,
			'tinymce-editor': Editor 
		},
		props:{ 
			id:{
				required: true
			},
		},
		data () {
			return {
				branch : {},
				edit : false,
				messagetypes : [],
				allUsers : [],
				messagetype: false,
				showConfirm: false,
				message : { 'data': {'title':'', 'content':''}},
				messages :[],
				pagination:{
					'current' 	: 1,
					'first'		: 1,
					'last'		: 1,
					'num'		: 1,
				},
				search : {
					'branch_id'			: this.id,
					'messagetype_id' 	: false,
					'user_id' 			: false,
					'keywords'			: '',
				},
				endpoint: this.$store.state.endpoint,
				user: this.$store.state.user,
				removeBtn : false,
				selectedfiles:[],
				edittingfiles:[]
			}
		},
		computed:{
			page : function(){
				return this.pagination;
			},
			allow_sent:function(){
				if(this.message.data.title){
					if(this.message.data.title.length>0){
						if(this.message.data.content){
							if(this.message.data.content.length>0){
								return true;
							}
						}
					}
				}

				return false;
			}
		},
		methods:{
			triggerAddFile:()=>{
				document.getElementById('addfile').click();
			},
			checkImageFile:function(type){
				let formats=['png','JPG','JPEG','jpg','jpeg','PNG'];
				//checking the if the file format is supported
				let check=formats.find(fmt=> fmt == type);

				if(check){
					return true;
				}

				return false;
			},
			readSelectedFile:function(){ 
				let file=document.getElementById('addfile').files[0];
				
				if(!file){
					return false;
				}
				
				let formats=['application/pdf','image/png','image/JPG','image/JPEG','image/jpg','image/jpeg'];
				//checking the if the file format is supported
				let check=formats.find(fmt=> fmt == file.type);

				if(!check){
					alert("File format not supported.");
					return false;
				}

				//push the file into files array
				this.selectedfiles.push(file); 
				// console.log(this.selectedfiles);
			},

			removefile:function(index){
				
				let temp=this.selectedfiles.filter((file,indx)=>{ 
					if(index == indx){  
						return false;
					}
					return true;
				});

				this.selectedfiles=[];
				// console.log(temp);
				this.selectedfiles=temp;
				
			},
			removeedittingfile:function(index){
				
				let temp=this.edittingfiles.filter((file,indx)=>{ 
					if(index == indx){  
						return false;
					}
					return true;
				});

				this.edittingfiles=[];
				// console.log(temp);
				this.edittingfiles=temp;
				
			},
			editing: function(){
				this.edit = true;
			},
			editMessage: function(id){
				var message = this.messages[this.messages.findIndex(x => x.id === id)];
			 	this.edittingfiles=message.files;
				this.removeBtn = true;
				this.showConfirm = false;
				this.message.data = {'id' : id,'content' : message.content, 'title' : message.title};
				this.messagetype = message.messagetype_id;
				this.message.type = this.messagetypes[this.messagetypes.findIndex(x => x.id === message.messagetype_id)];
			},
			createMessage: function(id){
				this.removeBtn = false;
				this.showConfirm = false;
				this.messagetype = id;
				this.message.data = {'content' : '', 'title' : ''};

				this.message.type = this.messagetypes[this.messagetypes.findIndex(x => x.id === id)];
			},
			storeMessage: function(){
				var data = this.message.data;
					data['branch_id'] = this.id;
					data['messagetype_id'] = this.messagetype;

				
					let formdata=new FormData();
					formdata.append('title',data['title']);
					formdata.append('content',data['content']);
					formdata.append('branch_id',data['branch_id']);
					formdata.append('messagetype_id',data['messagetype_id']);

					this.selectedfiles.forEach((element,index) => {
						formdata.append('file'+index , element);
					}); 
					this.$store.state.requestStatus.show=true;
					this.$store.state.requestStatus.perc=0;
				this.$store.dispatch("post",{endpoint:this.$store.state.endpoint+'messages?token='+this.$store.state.token,details:formdata})
				.then(data=>{

					this.$store.state.requestStatus.show=false;
					this.$store.state.requestStatus.perc=0;

					if(data.data.code == "-1"){
						this.showErrormessage(data.data.msg);
					}else{
						this.edit = false;
						this.cancelMessage();
						this.showErrormessage('Bericht opgeslagen');
	                	this.$store.dispatch("get",this.$store.state.endpoint+'messages/branch/'+this.id+'?page=1&token='+this.$store.state.token)
					    .then(data=>{  
					        this.messages=data.data.data;
					       	this.pagination.num 	= data.data.meta.last_page;
					       	this.pagination.first = 1;
					       	this.pagination.last 	= data.data.meta.last_page;
					    }) 
					    .catch(error=>{
					        if(error.request.status == 401){
					            this.error=true;
					            this.error_msg="invalid login details";
					        }
					    });
					}
            	})
            	.catch(error=>{
					this.$store.state.requestStatus.show=false;
					this.$store.state.requestStatus.perc=0;
					console.log(error);
            		this.showErrormessage(error);
            	});
			},
			updateMessage: function(){
				console.log('bericht', this.message);

				var data = this.message.data;
					data['branch_id'] = this.id;
					
					let formdata=new FormData();
					formdata.append('title',data['title']);
					formdata.append('content',data['content']);
					formdata.append('branch_id',data['branch_id']);
					formdata.append('messagetype_id',data['messagetype_id']);
					formdata.append('existingfiles',JSON.stringify(this.edittingfiles));
					
					this.selectedfiles.forEach((element,index) => {
						formdata.append('file'+index , element);
					});
 
					this.$store.state.requestStatus.show=true;
					this.$store.state.requestStatus.perc=0;
				this.$store.dispatch("post",{endpoint:this.$store.state.endpoint+'messages/updatemessage/'+data['id']+'?token='+this.$store.state.token , details:formdata})
				.then(data=>{
					this.$store.state.requestStatus.show=false;
					this.$store.state.requestStatus.perc=0;

					if(data.data.code == "-1"){
						this.showErrormessage(data.data.msg);
					}else{
						this.edit = false;
						this.cancelMessage();
						this.showErrormessage('Bericht bewerkt');
	                	this.$store.dispatch("get",this.$store.state.endpoint+'messages/branch/'+this.id+'?page=1&token='+this.$store.state.token)
					    .then(data=>{  
					        this.messages=data.data.data;
					       	this.pagination.num 	= data.data.meta.last_page;
					       	this.pagination.first = 1;
					       	this.pagination.last 	= data.data.meta.last_page;
					    }) 
					    .catch(error=>{
					        if(error.request.status == 401){
					            this.error=true;
					            this.error_msg="invalid login details";
					        }
					    });
					}
            	})
            	.catch(error=>{
					this.$store.state.requestStatus.show=false;
					this.$store.state.requestStatus.perc=0;
            		this.showErrormessage(error);
            	});
			},
			deleteMessage: function(){
				console.log('bericht', this.message);
				this.$store.dispatch("get", this.$store.state.endpoint+'messages/'+this.message.data['id']+'/delete?token='+this.$store.state.token)
				.then(data=>{
					if(data.data.code == "-1"){
						this.showErrormessage(data.data.msg);
					}else{
						this.edit = false;
						this.cancelMessage();
						this.showErrormessage('Bericht succesvol verwijderd');
	                	this.$store.dispatch("get",this.$store.state.endpoint+'messages/branch/'+this.id+'?page=1&token='+this.$store.state.token)
					    .then(data=>{  
					        this.messages=data.data.data;
					       	this.pagination.num 	= data.data.meta.last_page;
					       	this.pagination.first = 1;
					       	this.pagination.last 	= data.data.meta.last_page;
					    }) 
					    .catch(error=>{
					        if(error.request.status == 401){
					            this.error=true;
					            this.error_msg="invalid login details";
					        }
					    });
					}
            	})
            	.catch(error=>{
            		this.showErrormessage(error);
            	});
			},
			confirmCancel: function(){
				this.edit = false;
				this.cancelMessage();
			},
			cancelMessage: function(){
				this.edittingfiles=[];
				this.selectedfiles=[]; 
				
				if(!this.edit){
					this.messagetype = false;
					this.showConfirm = false;
				}else{
					$('#confirmModal').modal('toggle');
					this.showConfirm = true;
				}
			},
			goToPage : function(num){
				if(num==='pageNumber'){
					this.pagination.current;
				}else{
					this.pagination.current=num;
				}

				this.$store.dispatch("get",this.$store.state.endpoint+'messages/branch/'+this.id+'?page='+this.pagination.current+'&token='+this.$store.state.token)
			    .then(data=>{
			        this.messages=data.data.data;
			       	this.pagination.num 	= data.data.meta.last_page;
			       	this.pagination.first = 1;
			       	this.pagination.last 	= data.data.meta.last_page;
			       	// window.console.log('data',data);
			    }) 
			    .catch(error=>{
			        if(error.request.status == 401){
			            this.error=true;
			            this.error_msg="invalid login details";
			        }
			    });
			},

			submitMessage: function(){

			},

			searchMessages: function(){
				this.$store.dispatch("post",{endpoint:this.$store.state.endpoint+'messages/search?token='+this.$store.state.token, details: this.search})
			    .then(data=>{  
			        this.messages=data.data.data;
			        this.pagination = false;
			    }) 
			    .catch(error=>{
			        if(error.request.status == 401){
			            this.error=true;
			            this.error_msg="invalid login details";
			        }
			    });
			},

			timeCheck : function(message){
				var t1 = new Date(message.created_at).getTime();
		        var t2 = new Date().getTime();
		        var numHours = parseInt((t2-t1)/(3600*1000));
		        
		        if(numHours>=24){
		        	return false;
		        }else{
		        	return true;
		        }
			}
		},
		created(){
			 
		    // REQUESTING BRANCH DATA
		    this.$store.dispatch("get", this.$store.state.endpoint+"branches/"+this.id+'?token='+this.$store.state.token)
		    .then(data=>{  
		        this.branch=data.data.data;
		        // window.console.log('data',data); 
		       
		    }) 
		    .catch(error=>{
				console.log(error.request);
		        if(error.request.status == 401){
		            this.error=true;
		            this.error_msg="invalid login details";
		        }
		        window.console.log(error.request.response);
		        
		    });

		    this.$store.dispatch("get", this.$store.state.endpoint+"messagetypes/branch/"+this.id+'?token='+this.$store.state.token)
		    .then(data=>{
		        this.messagetypes=data.data.data;
		        // window.console.log('data',data);
		       
		    }) 
		    .catch(error=>{
		        if(error.request.status == 401){
		            this.error=true;
		            this.error_msg="invalid login details";
		        }
		    });

		    this.$store.dispatch("get",this.$store.state.endpoint+'messages/branch/'+this.id+'?page=1&token='+this.$store.state.token)
		    .then(data=>{   
		        this.messages=data.data.data;
		    	console.log('messages', data.data.data);
		       	this.pagination.num 	= data.data.meta.last_page;
		       	this.pagination.first = 1;
		       	this.pagination.last 	= data.data.meta.last_page;
		    }) 
		    .catch(error=>{
		        if(error.request.status == 401){
		            this.error=true;
		            this.error_msg="invalid login details";
		        }
		    });

		    
			this.$store.dispatch("get",this.$store.state.endpoint+'users?token='+this.$store.state.token)
		    .then(data=>{   
		        this.allUsers=data.data.data;
		    }) 
		    .catch(error=>{
		        if(error.request.status == 401){
		            this.error=true;
		            this.error_msg="invalid login details";
		        }
		    });
		    console.log('user:', this.user);
		}
	}
</script>

<style lang="css" scoped>
	#AlertModal.show{
		display: block;
	}
	#AlertModal .modal-dialog{
		position: fixed;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
		margin: auto;
		display: block !important;
		width: fit-content;
		height: fit-content;
		
	}
	#AlertModal::after{
		display: block;
		position: fixed;
		content:'';
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
		margin: auto;
		width: 100%;
		height:100%;
		background: #00000099;
		z-index: -1 !important;
	}
	#AlertModal .modal-body{
		background: aliceblue;
		border-radius: 5px;
	}
	#AlertModal .modal-footer{
		padding: 2px;
	}
	#AlertModal .modal-footer .btn{
		background: transparent;
		color: #000;
		outline: 0px  !important;
		box-shadow: none;
		border:none;
	}
.filesholder{
	margin-top:20px;
	white-space: nowrap;
	/*overflow-x: scroll;*/
}
 
.filesholder .file{ 
	width: 60px;
	height:60px;
	background-position: center !important;
	background-size: cover !important;
	background-repeat: no-repeat !important;
	display: inline-block;
	margin-right: 5px;
}
.filesholder .file:hover{
	transform: scale(0.97);
}
.btn-confirm{
	margin-top: -4px;
}
#pageNumberPageItem{
	border-top: 1px solid #d4af37;
	border-bottom: 1px solid #d4af37;
	padding: 0px 10px 0px 4px;
}
#pageNumber{
	height: 33px !important;
	background-color: #000;
	color: #FFF;
	border-radius: 0px;
	border: 0px;
	margin-left: 5px;
	margin-right: 5px;
}
</style>